import React from 'react';

import Header from '../components/HeaderSection/HeaderMobiCloud';
import HeroSection from '../components/HeroSection/HeroMobiCloud';
import Counter from '../components/CounterSection/CounterMobiCloud';
import FeatureSection from '../components/Features/FeatureMobiCloud';
import ServiceSection from '../components/ServiceSection/ServiceMobiCloud';
import DiscoverSection from '../components/DiscoverSection/DiscoverMobiCloud';
import Work from '../components/WorkSection/WorkMobiCloud';
// import ScreenshotSection from '../components/ScreenshotSection/ScreenshotsMobiCloud';
// import ReviewSection from '../components/ReviewSection/ReviewMobiCloud';
// import PricingSection from '../components/PricingSection/PricingMobiCloud';
// import FaqSection from '../components/FaqSection/FaqMobiCloud';
// import Download from '../components/DownloadSection/DownloadMobiCloud';
// import Subscribe from '../components/SubscribeSection/SubscribeMobiCloud';
// import Team from '../components/TeamSection/TeamMobiCloud';
import ContactSection from '../components/ContactSection/ContactMobiCloud';
import FooterSection from '../components/FooterSection/FooterMobiCloud';

const ThemeMobiCloud = () => {
    return (
        <div className="homepage-mobicloud">
            {/*====== Scroll To Top Area Start ======*/}
            <div id="scrollUp" title="Scroll To Top">
                <i className="fas fa-arrow-up" />
            </div>
            {/*====== Scroll To Top Area End ======*/}
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                <HeroSection />
                <FeatureSection />
                <ServiceSection />
                <DiscoverSection />
                <Work />
                {/* <ScreenshotSection /> */}
                {/* <ReviewSection /> */}
                {/* <PricingSection /> */}
                {/* <FaqSection /> */}
                {/* <Team /> */}
                {/* <Download /> */}
                {/* <Subscribe /> */}
                <ContactSection />
                <FooterSection />
            </div>
        </div>
    );
};

export default ThemeMobiCloud; 